import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import AppWrapper from '../../../components/AppWrapper';
import Button from '../../../components/Button';
import ErrorMessage from '../../../components/ErrorMessage';
import { LinkComponent } from '../../../components/Link';
import { TextH3, TextP } from '../../../components/Text';
import { useUser } from '../../../hooks';
import * as Styled from '../../../styles/EditDeleteStyles';
import { fonts } from '../../../styles/theme';

const UserDelete = () => {
  const location: any = useLocation();
  const params = useParams();

  const {
    nameSingle,
    name,
    baseUrl,
    users,
    selectUsers,
    setSelectUsers,
    handleDelete,
    getUsersById,
    getBreadcrumbs,
    errors,
  } = useUser();

  useEffect(() => {
    if (location.state?.ids) {
      setSelectUsers(location.state.ids);
      getUsersById(location.state.ids);
    }
  }, [location]);

  useEffect(() => {
    if (params.id) {
      setSelectUsers([parseInt(params.id, 10)]);
      getUsersById([parseInt(params.id, 10)]);
    }
  }, [params]);

  return (
    <AppWrapper breadcrumbs={getBreadcrumbs()}>
      <Styled.TextWrapper>
        <TextH3 font={fonts.font1.H20}>Are you sure?</TextH3>
      </Styled.TextWrapper>
      {Object.keys(errors).length > 0 && (
        <ErrorMessage message={errors.message} />
      )}
      {users.length === 1 ? (
        <TextP font={fonts.font1.H14}>
          Are you sure you want to delete the {nameSingle} “{users[0].first_name} {users[0].last_name}({users[0].email})”? All of the following related items will be deleted:
        </TextP>
      ) : (
        <TextP font={fonts.font1.H14}>
          Are you sure you want to delete the selected {name}? All of the following objects and their related items will be deleted:
        </TextP>
      )}
      <div>
        <Styled.TextWrapper>
          <TextP font={fonts.font1.H16B}>Summary</TextP>
          <Styled.ListStyled>
            <li>
              {name}: {users.length}
            </li>
          </Styled.ListStyled>
        </Styled.TextWrapper>
      </div>
      <div>
        <TextP font={fonts.font1.H16B}>Objects</TextP>
        {users && (
          <Styled.ListStyled>
            {users?.map((authority: { name?: string, id?: number }) => (
              <li key={authority.id}>
                {nameSingle}: {authority.id}
                <LinkComponent url={`/${baseUrl}}/${authority.id}`}>
                  {authority.name}
                </LinkComponent>
              </li>
            ))}
          </Styled.ListStyled>
        )}
        <Styled.FlexBoxStyled>
          <Button
            onClick={() => handleDelete(selectUsers)}
            theme="warning"
          >
            <TextP font={fonts.font1.H12}>Yes, I&apos;m sure</TextP>
          </Button>
          <Styled.ButtonWrapper>
            <LinkComponent
              url={users.length === 1 ? `/${baseUrl}/${users[0].id}/change` : `/${baseUrl}`}
              theme="buttonSecondary"
            >
              <div>
                <TextP font={fonts.font1.H12}>
                  No, take me back
                </TextP>
              </div>
            </LinkComponent>
          </Styled.ButtonWrapper>
        </Styled.FlexBoxStyled>
      </div>
    </AppWrapper>
  );
};

export default UserDelete;
